import { Coins } from 'lucide-react';
import type { IExpenseResult } from '../../../../models/expense/ExpenseModel';
import styles from '../ExpenseManagement.module.css';

export type ExpenseAmountCellProps = {
  row: IExpenseResult;
};

const ExpenseAmountCell = ({ row }: ExpenseAmountCellProps) => {
  const formatted = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  }).format(row.amount);

  return (
    <span className={styles.amountCell}>
      <Coins size={16} strokeWidth={2} className={styles.amountIcon} />
      {formatted}
    </span>
  );
};

export default ExpenseAmountCell;
